import React from 'react';
import Christmas2025 from 'views/Christmas2025';

const MathClubPage = () => {
  return <Christmas2025/>;
};

export default MathClubPage;

